export default "__VITE_ASSET__B0K7OQlZ__"